import { Error } from "@/components/admin/error";
import { Notification } from "@/components/admin/notification";
import { Skeleton } from "@/components/ui/skeleton";
import { Suspense, type ReactNode } from "react";
import { ErrorBoundary } from "react-error-boundary";

import { BillingBanner, BillingBlocked } from "../billing/BillingBanner";
import { useBillingState } from "../billing/useBilling";
import { DataImportProvider } from "../dataImport/DataImportProvider";
import { useConfigurationLoader } from "../root/useConfigurationLoader";
import { WelcomeSplash } from "../welcome/WelcomeSplash";
import { MobileNavigation } from "./MobileNavigation";
import { PullToRefresh } from "./PullToRefresh";

export const MobileLayout = ({ children }: { children: ReactNode }) => {
  useConfigurationLoader();
  const billing = useBillingState();
  if (billing.kind === "blocked") {
    return (
      <>
        <BillingBlocked />
        <Notification mobileOffset={{ bottom: "72px" }} />
      </>
    );
  }
  return (
    <DataImportProvider>
      <BillingBanner state={billing} />
      <PullToRefresh />
      <ErrorBoundary FallbackComponent={Error}>
        <Suspense fallback={<Skeleton className="h-12 w-12 rounded-full" />}>
          {children}
        </Suspense>
      </ErrorBoundary>
      <MobileNavigation />
      <Notification mobileOffset={{ bottom: "72px" }} />
      <WelcomeSplash />
    </DataImportProvider>
  );
};
